import React from 'react'
import { Link } from '@reach/router'
import 'react-metismenu/dist/react-metismenu-standart.min.css'

export class SideBarLink extends React.Component {
  constructor() {
    super()
    this.onClick = this.onClick.bind(this)
  }
  onClick(e) {
    if (this.props.hasSubMenu) this.props.toggleSubMenu(e)
    else {
      this.props.activateMe &&
        this.props.activateMe({
          newLocation: this.props.to, //eslint-disable-line
          selectedMenuLabel: this.props.label,
        })
    }
  }
  render() {
    return (
      <Link
        {...this.props}
        getProps={({ isCurrent, isPartiallyCurrent }) => {
          const isActive = this.props.partial ? isPartiallyCurrent : isCurrent
          return {
            style: {
              color: isActive ? '#ff0000' : '#fff',
            },
          }
        }}
        onClick={this.onClick}
      ></Link>
    )
  }
}
